export enum EDroneFlyingMode {
  DFM_None,
  DFM_Flying,
  DFM_Travel,
}
